import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import store from "./store";
import store from "./store/store";

/*** Start Argon Dependencies ***/
import "bootstrap"; // v4.1.3
import "@/assets/argon_theme/js/argon";
/*** End Argon Dependencies ***/

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
